import { useEffect, useState } from 'react';

export interface ToastAction {
  label: string;
  onClick: () => void;
}

export function useToast() {
  const [toast, setToast] = useState<{ message: string; action?: ToastAction } | null>(null);
  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => setToast(null), 2300);
    return () => clearTimeout(t);
  }, [toast]);
  return {
    message: toast?.message ?? null,
    action: toast?.action ?? null,
    show: (message: string, action?: ToastAction) =>
      setToast({ message, action: action ? { ...action, onClick: () => { action.onClick(); setToast(null); } } : undefined }),
  };
}

export default function Toast({
  message,
  action,
}: {
  message: string | null;
  action?: ToastAction | null;
}) {
  if (!message) return null;
  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[99] rounded-lg bg-ink text-cream px-4.5 py-2.5 text-sm shadow-[0_6px_24px_oklch(24%_0.02_50_/_0.25)] flex items-center gap-4">
      <span>{message}</span>
      {action && (
        <button onClick={action.onClick} className="font-semibold underline decoration-1 underline-offset-2 hover:text-sage">
          {action.label}
        </button>
      )}
    </div>
  );
}
